import { render, staticRenderFns } from "./TabRouteView.vue?vue&type=template&id=6e479ae3&scoped=true"
import script from "./TabRouteView.vue?vue&type=script&lang=js"
export * from "./TabRouteView.vue?vue&type=script&lang=js"
import style0 from "./TabRouteView.vue?vue&type=style&index=0&id=6e479ae3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e479ae3",
  null
  
)

export default component.exports